import React from 'react'
import InvoiceNotAvailable from './download-section/InvoiceNotAvailable'
import InvoiceError from './download-section/InvoiceError'
import NoInvoices from './download-section/NoInvoices'
import InvoiceLoading from './download-section/InvoiceLoading'
import MonthlyInstallmentInvoices from './download-section/MonthlyInstallmentInvoices'
import SingleInvoice from './download-section/SingleInvoice'

interface DownloadSectionProps {
  channel: string
  pmsSource?: string
  isHilton?: boolean
  folios: any[]
  isError: boolean
  isLoading: boolean
  checkinDate?: string
  checkoutDate?: string
  reservationId: string
  isMonthlyStay: boolean
  onDownloadSingle: (folio: any) => void
  onDownloadAll: () => void
  downloadingInvoiceId?: string | null
}

const DownloadSection: React.FC<DownloadSectionProps> = ({
  channel,
  pmsSource,
  isHilton,
  folios,
  isError,
  isLoading,
  checkinDate,
  checkoutDate,
  reservationId,
  isMonthlyStay,
  onDownloadSingle,
  onDownloadAll,
  downloadingInvoiceId
}) => {
  // Direct, IBE, and Hilton bookings can download invoices.
  //   - `channel` is the Apaleo channelCode (e.g. "Direct", "Ibe", "Hilton",
  //     or an OTA value).
  //   - `pmsSource` is the Apaleo `source` field — more reliable for
  //     identifying Hilton bookings ("Hilton").
  //   - `isHilton` is a HubSpot deal property that may serialize as the
  //     literal string "true" rather than a boolean.
  const isHiltonFlag = isHilton === true || (isHilton as unknown) === 'true'
  const canDownloadInvoice =
    channel === 'Direct' ||
    channel === 'Ibe' ||
    channel === 'Hilton' ||
    pmsSource === 'Hilton' ||
    isHiltonFlag

  const hasNoInvoices = !isLoading && folios.length === 0
  const isMonthlyInstallment = isMonthlyStay

  if (!canDownloadInvoice) {
    return <InvoiceNotAvailable />
  } else if (isError) {
    return <InvoiceError />
  } else if (hasNoInvoices) {
    return <NoInvoices />
  } else if (isLoading) {
    return <InvoiceLoading />
  } else if (isMonthlyInstallment) {
    return (
      <MonthlyInstallmentInvoices
        folios={folios}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        onDownloadSingle={onDownloadSingle}
        downloadingInvoiceId={downloadingInvoiceId}
      />
    )
  } else {
    return <SingleInvoice isLoading={isLoading} onDownloadAll={onDownloadAll} />
  }
}

export default DownloadSection
